import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { domaQuery } from "../../services/payments/DomaQueryService";
import { queryKeys } from "@/utils/queryKeys";
const DOMAS_SEARCH_LIMIT = 200;
export const useDomas = subsidiaryId => {
  const $ = _c(8);
  let t0;
  if ($[0] !== subsidiaryId) {
    t0 = queryKeys.payments.domas(subsidiaryId);
    $[0] = subsidiaryId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== subsidiaryId) {
    t1 = () => domaQuery.search({
      search: {
        filters: [{
          field: "subsidiary_id",
          operator: "=",
          value: subsidiaryId
        }],
        sorts: [{
          field: "code",
          direction: "asc"
        }],
        limit: DOMAS_SEARCH_LIMIT
      }
    });
    $[2] = subsidiaryId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = subsidiaryId !== null;
  let t3;
  if ($[4] !== t0 || $[5] !== t1 || $[6] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return useQuery(t3);
};